export default __webpack_public_path__ + "static/media/not_pass.ceee4966.png";